

import React, { useState, ChangeEvent, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { deleteDocument, submitEnclosureFiles } from '../../auth/services/privateapicalling';
import { Link } from 'react-router-dom';

import ExperienceEdit from './ExperienceEditModal';
import { toast, ToastContainer } from 'react-toastify';

interface ExperienceProps {
  title: string;
  list: any[];
  setList: (list: any[]) => void;
  onChange: (values: string[]) => void;
  docName:string
  existData:any
  count:number
  onAdd:()=>void
  onEditClick: (entry: any, modalId: string , list:any[] , docName:string ) => void;
  modalId:string,
  loading:boolean
  setLoading: (loading: boolean) => void;
}

const Section: React.FC<ExperienceProps> = ({ title, list, setList, onChange , docName, existData , count ,onAdd , onEditClick, modalId , loading , setLoading}) => {

    const userdetails = useSelector((state: any) => state.auth.userDetails);
    const token = useSelector((state: any) => state.auth.token);
    
  const language = useSelector((state: any) => state.auth.language);
  const formLanguage = useSelector((state: any) => state.auth.formLanguage)
  

  const [formData, setFormData] = useState({
    projectName: "",
    projectAwardedby:"",
    startDate: "",
    endDate: "",
  });
  // const [loading, setLoading] = useState(false);

  const [files, setFiles] = useState<{ [key: string]: File | null }>({});
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [isValid, setIsValid] = useState<boolean | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const [selectedExperience, setSelectedExperience] = useState(null);

  // ✅ Validation schema
  const validationSchema = Yup.object().shape({
    projectName: Yup.string().matches(/^[A-Za-z0-9\s]+$/, "Project name cannot contain special characters").
    required("Project name is required").max(50, "Project name cannot exceed 50 characters"),
    projectAwardedby: Yup.string().matches(/^[A-Za-z0-9\s]+$/, "Project Awarded cannot contain special characters").
    required("Project Awarded by is required").max(50, "Project Awarded by cannot exceed 50 characters"),

    startDate: Yup.string()
  .required("Start date is required")
  .test("not-future", "Start date cannot be in the future", function (value) {
    return new Date(value!) <= new Date(); // Ensures the start date is not in the future
  }),

endDate: Yup.string()
  .required("End date is required")
  .test("is-after-start", "End date must be after start date", function (value) {
    return new Date(value!) > new Date(this.parent.startDate); // Ensures end date is after start date
  })
  .test("not-future", "End date cannot be in the future", function (value) {
    return new Date(value!) <= new Date(); // Ensures the end date is not in the future
  })
,

      evidence: Yup.mixed()
      .required("Evidence file is required.")
      .test("file-required", "Evidence file is required.", function (value) {
        return value != null;
      })
      .test("fileFormat", "Only PDF, JPG, and JPEG files are allowed.", function (value) {
        if (!value) return false;
        const allowedFormats = ["application/pdf", "image/jpeg", "image/jpg"];
        return value instanceof File && allowedFormats.includes(value.type);
      })
      .test("fileSizeMax", "File size must be less than 3MB.", (value) => {
        if (!value || !(value instanceof File)) return false;
        return value.size <= 3 * 1024 * 1024; // 3 MB
      })
      .test("fileSizeMin", "File size must be at least 40KB.", (value) => {
        if (!value || !(value instanceof File)) return false;
        return value.size >= 40 * 1024; // 50 KB
      }),
    
  });

  // ✅ Handle input changes
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, files: selectedFiles } = e.target;
    if (selectedFiles && selectedFiles.length > 0) {
      setFiles((prevFiles) => ({
        ...prevFiles,
        [name]: selectedFiles[0],
      }));

      
    }
  };

  // ✅ Check validity
const findFirstMissingIndex = (experienceDetail) => {
  const indices = new Set(experienceDetail?.map(item => item.index) || []);
  let index = 1;
  while (indices.has(index)) index++;
  return index;
};
  const checkValidity = async () => {
    try {
      await validationSchema.validate(
        { ...formData, evidence: files.evidence },
        { abortEarly: false }
      );
      setErrors({});
      setIsValid(true);
      //.log("✅ Form is valid");
      return true;
    } catch (err: any) {
      const newErrors: { [key: string]: string } = {};
      err.inner.forEach((e: any) => {
        newErrors[e.path] = e.message;
      });
      setErrors(newErrors);
      setIsValid(false);
      //.log(" Form is invalid", newErrors);
      return false;
    }
  };

  // ✅ Add new entry
  const addEntry = async () => {
    setLoading(true);
    const isValid = await checkValidity();
    //.log("Is valid:", isValid);

    if (isValid) {
        const uploadData = new FormData();
        //.log('eeee',files.evidence)
        //.log('listLength', list.length)
        //.log('docc name' , `${docName}_${list?.length + 1}`)
        const nextIndex = findFirstMissingIndex(list);
        uploadData.append("file", files.evidence as Blob);
        uploadData.append("documentName", `${docName}_${nextIndex}`);
        uploadData.append("applicationId", existData.applicationId);

    const existingDoc = existData && existData.docs?.find((doc: any) => doc.documentName === `${docName}_${nextIndex}`);

    const uploadDoc = await submitEnclosureFiles(uploadData , token ,  existingDoc?.docId);
    //.log('submitted edu ress' , uploadDoc);
      if(uploadDoc.success ==true){
          // toast.success(uploadDoc?.message)
        const eveidenceProof={
            "docId":uploadDoc.data.id,
            "documentName":uploadDoc.data.documentName,
            "fileName":uploadDoc.data.fileName,

        }
        // debugger
        const newEntry = { ...formData , eveidenceProof ,index:nextIndex};
        //.log('new entryy' , newEntry)
      const updatedList = [...list, newEntry].sort((a, b) => a.index - b.index);
        setList(updatedList);
        //.log('updated list', updatedList);
  
        onChange(updatedList);
        // onAdd();
        // Reset form and errors
        setFormData({ projectName: "",projectAwardedby:"", startDate: "", endDate: "" });
        setFiles({});
        setErrors({});

        if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
      }
      else
      // alert(`${uploadDoc.message}`)
      toast.error(uploadDoc?.message, {
        position: "top-center",
        autoClose: 3000,
      });
      setLoading(false);

    }
    else{
      setLoading(false);

    }
  };



    const deleteEducation = async (entry: any , docName:string) => {
      
      
      const fieldMapping = {
        experienceDoc: "experienceDetail",
        workPerformanceDoc:"govSemiGovExpDetail",
        constructionDocs:"marketPublicConstructionDetail"
        
      }
     
      const body = {
        docId: entry.eveidenceProof.docId,
        applicationId: existData.applicationId,
        fieldName: fieldMapping[docName],
      }
     
      try {
        const res = await deleteDocument(body, token);
        if(res.success==true)
        {
          onAdd();
      
        }
        
        
      } catch (error) {
        toast.error("Error deleting  entry");
        
      }
    };



  useEffect(() => {
    //.log("Files:", files);
    setSelectedExperience(null);
  }, []);

  return (
    <>
    <div className="row mb-4">
      {/* Left Side: Form */}
      <div className="col-md-6">
        <div className="card p-3 shadow-sm">
          <h5 className="mb-3">{language.fill} {title} -</h5>

          {/* Project Name */}
          <div className="mb-3">
            <label className="form-label">
            {formLanguage.project_name} ({language.project_name}) {title=="Experience Details" && <span className="text-danger">*</span>}
            </label>
            <input
              type="text"
              className="form-control"
              name="projectName"
              value={formData.projectName}
              onChange={handleInputChange}
            />
            {errors.projectName && <small className="text-danger">{errors.projectName}</small>}
          </div>

          <div className="mb-3">
            <label className="form-label">
            {formLanguage.project_awarded_by} ({language.project_awarded_by}){ title=="Experience Details" &&  <span className="text-danger">*</span>}
            </label>
            <input
              type="text"
              className="form-control"
              name="projectAwardedby"
              value={formData.projectAwardedby}
              onChange={handleInputChange}
            />
            {errors.projectAwardedby && <small className="text-danger">{errors.projectAwardedby}</small>}
          </div>

          {/* File Input */}
          <div className="mb-3">
            <label className="form-label">{formLanguage.attested_copy} ({language.attested_copy}) {title=="Experience Details" && <span className="text-danger">*</span>}
            </label>
            <p className="text-danger mb-1">{language.file_type}</p>
            <input type="file" className="form-control" name="evidence" accept=".pdf,  .jpeg, .jpg"  ref={fileInputRef}  onChange={handleFileChange} />
            {errors.evidence && <small className="text-danger">{errors.evidence}</small>}
          </div>

          {/* Start Date */}
          <div className="mb-3">
            <label className="form-label">
            {formLanguage.start_date} ({language.start_date}) {title=="Experience Details" && <span className="text-danger">*</span>}
            </label>
            <input
              type="date"
              className="form-control"
              name="startDate"
              value={formData.startDate}
              onChange={handleInputChange}
              max={new Date().toISOString().split("T")[0]} 
            />
            {errors.startDate && <small className="text-danger">{errors.startDate}</small>}
          </div>

          {/* End Date */}
          <div className="mb-3">
            <label className="form-label">
            {formLanguage.end_date}  ({language.end_date}) {title=="Experience Details" && <span className="text-danger">*</span>}
            </label>
            <input
              type="date"
              className="form-control"
              name="endDate"
              value={formData.endDate}
              min={formData.startDate}
              max={new Date().toISOString().split("T")[0]} 
              onChange={handleInputChange}
              
            />
            {errors.endDate && <small className="text-danger">{errors.endDate}</small>}
          </div>

          {/* Add Button */}
          {/* <button className="btn btn-primary" onClick={addEntry}>
            + {language.add}
          </button> */}
          <button className="btn btn-primary" onClick={addEntry} disabled={loading}>
          {loading ? (
            <i className="ion-load-a ion-spin"></i> // Loading spinner
          ) : (
            `+ ${language.add}` // Add button text
          )}
        </button>
        </div>
      </div>

      {/* Right Side: Table */}
      <div className="col-md-6">
        <div className="card p-3 shadow-sm">
          <h5 className="mb-3">{title}</h5>
          {list.length > 0 ? (
            <div className="table-responsive">
                 <table className="table table-bordered">
              <thead className="table-light">
                <tr>
                  <th>Sr No</th>
                  <th>{language.project_name}</th>
                  <th>{language.project_awarded_by}</th>
                  <th>{language.attachements}</th>
                  <th>{language.start_date}</th>
                  <th>{language.end_date}</th>
                  <th>{language.action}</th>
                  <th></th>

                </tr>
              </thead>
              <tbody>
                {list.map((entry, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{entry.projectName}</td>
                    <td>{entry.projectAwardedby}</td>
                    <td>{entry.eveidenceProof.fileName}</td>
                    <td>{entry.startDate}</td>
                    <td>{entry.endDate}</td>
                    <td>
                       <Link
                        to="#"
                        // data-bs-toggle="modal" 
                        // data-inert={true}
                        // data-bs-target={modalId}
                        className="d-flex btn btn-primary align-items-center w-32 "
                        onClick={() => onEditClick(entry, modalId , list , docName)} 
                        >
                            <i className="me-2 ti ti-edit" />
                            {language.edit}
                        </Link>   
                    </td>
                    <td>
                        <button className="d-flex btn btn-danger align-items-center " onClick={() => deleteEducation(entry , docName)}>🗑 {language.delete}</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>  
         
          ) : (
            <p className="text-muted">No entries added yet.</p>
          )}
        </div>
        
      </div>
    </div>
    {/* <ExperienceEdit title={title}  selectedExperience={selectedExperience} appId={existData.applicationId} list={list}  setList={setList} onChange={onChange}  /> */}
    </>
    
  ); 
};

export default Section;
